import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import './styles/App.css';
import TopTitle from './TopTitle';


function MyService() {
    return (
        <>
            <Container>
                <Row className="d-block">
                    <TopTitle title="내 서비스 관리" />

                    <div className="mt-5 s_service">
                        <h3 className="font-weight-bold">현재 가입된 서비스</h3>
                    </div>

                    <div className="mt-4 mb-5 s_bottom_line">
                        <h4 className="font-weight-bold m_steam">스팀세차 6회권</h4>
                        <h3 className="font-weight-bold">현재 가입된 서비스 이용내역</h3>
                    </div>
                    <div>
                        <table className="table table-bordered text-center">
                            <thead className="m_headbg">
                                <tr>
                                    <th>NO</th>
                                    <th>이용점</th>
                                    <th>상태</th>
                                    <th>사용일시</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <td>ㅇㅇ센텅ㅇ점</td>
                                    <td>시공(1회)</td>
                                    <td className="text-muted">21-01-02</td>
                                </tr>
                                <tr>
                                    <th>2</th>
                                    <td>ㅇㅇ센텅ㅇ점</td>
                                    <td>시공(1회)</td>
                                    <td className="text-muted">21-01-02</td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <td>ㅇㅇ센텅ㅇ점</td>
                                    <td>시공(1회)</td>
                                    <td className="text-muted">21-01-02</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="text-muted">
                        <span className="mb-3 d-block">[안내사항]</span>
                        <span className="d-block">*관련 서비스 이용 시 자동으로 우선 소진됩니다.</span>
                        <span className="">*서비스 가입을 원하실 경우 ㅇㅇ으로 문의 바랍니다.</span>
                    </div>
                </Row>
            </Container>
        </>
    );
}

export default MyService;